export function parseNumber(numberString: string | null): number | null {
  if (!numberString) return null;

  const normalized = numberString.replace(/,/g, ".");
  const parsed = parseFloat(normalized);

  return isNaN(parsed) ? null : parsed;
}
